import React from 'react'

class Footer extends React.Component {

  render(){
    return (
      <footer className="footer text-center"> 2017 &copy; Ted Yuen Copy Right </footer>
    )
  }
}

export { Footer }



// WEBPACK FOOTER //
// ./src/components/common/content/Footer.js